import { Longhand } from "../longhand.js";
import Base from "./top.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/inset-block-start}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=inset-block-start.js.map